import { render, staticRenderFns } from "./GlobalSnackBar.vue?vue&type=template&id=4ffb43f6&scoped=true"
import script from "./GlobalSnackBar.vue?vue&type=script&lang=js"
export * from "./GlobalSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb43f6",
  null
  
)

export default component.exports